<template>
  <div>
    <el-timeline>
      <el-timeline-item
        v-for="(item, index) in copyArr"
        :key="item.id"
        :timestamp="`${item.appealTime}  提交`"
        placement="top"
      >
        <el-card>
          <el-button-group style="margin-bottom:15px;">
            <el-button
              v-for="i in getBtnarr(item.appealType)"
              :key="i"
              :type="i == item.selectAppealType ? 'primary' : 'default'"
              @click="handleSelct(i, index)"
              size="small"
              >{{ i }}</el-button
            >
          </el-button-group>
          <div>
            {{
              item.selectAppealType === "运费异常"
                ? item.appealReasonPrice
                : item.selectAppealType === "轨迹异常"
                ? item.appealReasonPath
                : item.appealReasonOther
            }}
          </div>
          <div class="img_box">
            <el-image
              v-for="i2 in getImgUrl(item.selectAppealType, index)"
              :key="i2"
              style="width: 100px; height: 100px;margin:4px;"
              :src="i2"
              :preview-src-list="getImgUrl(item.selectAppealType, index)"
              fit="cover"
            />
          </div>
          <div class="review-info">
            <div v-if="item.reviewerName" class="review-item">
              审核人：{{ item.reviewerName }}
            </div>
            <div v-if="item.reviewTime" class="review-item">
              审核时间：{{ item.reviewTime }}
            </div>
            <div class="review-item">
              审核结果：
              {{
                item.status === 1 ? "通过" : item.status === 2 ? "驳回" : "--"
              }}
            </div>
            <div v-if="item.reviewRemark" class="review-item">
              审核意见：{{ item.reviewRemark }}
            </div>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
export default {
  name: "AppealRecord",
  props: {
    arr: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      copyArr: []
    };
  },
  watch: {
    arr: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.copyArr = JSON.parse(JSON.stringify(newVal));
          this.copyArr.forEach(item => {
            item.selectAppealType = item.appealType.split(",")[0];
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    getImgUrl(type, index) {
      let arr = [];
      if (type === "运费异常") {
        arr = this.copyArr[index].priceSupportingMaterials;
      } else if (type === "轨迹异常") {
        arr = this.copyArr[index].pathSupportingMaterials;
      } else if (type === "其他异常") {
        arr = this.copyArr[index].otherSupportingMaterials;
      }
      return arr;
    },
    handleSelct(item, index) {
      this.copyArr[index].selectAppealType = item;
      this.$forceUpdate();
    },
    getBtnarr(appealType) {
      return appealType.split(",");
    }
  }
};
</script>
<style scoped>
.img_box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.review-info {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  gap: 20px;
}
.review-item {
  flex: 0 0 calc(50% - 10px);
  min-width: 0;
}
</style>
